'use strict';

var React = require('react');
var tool = require('../../helper/tool');
var convertHelper = require('../../types/convertHelper');
var GlobalConst = require('../../types/GlobalConst');
var styleHelper = require('../../helper/styleHelper');

var LabelParts = React.createClass({
  propTypes: {
    partStyle: React.PropTypes.object
  },

  _getTextStyle: function () {

    var textStyle = {
      fontStyle: this.props.textStyles ? this.props.textStyles.fontStyle : 'normal',
      textDecoration: this.props.textStyles ? this.props.textStyles.textDecoration : 'normal',
      fontWeight: this.props.textStyles ? this.props.textStyles.fontWeight : 'normal',
      fontFamily: this.props.textFontFamily || '',
      color: styleHelper.getTextColor(this.props),
      fontSize: styleHelper.getFontSize(this.props),
      wordWrap: this.props.textWordWrap ? 'break-word' : 'nowrap',
      pointerEvents: 'none',
      textAlign: this.props.textAlign ? convertHelper.getTextHorizontalAlign(this.props.textAlign) : 'left',
      whiteSpace: 'nowrap'
    };

    return tool.extendObj(textStyle, this.props.partStyle);
  },

  render: function () {
    return (<label style={this._getTextStyle()}> {styleHelper.getText(this.props)} </label>)
  }

});

module.exports = LabelParts;



// WEBPACK FOOTER //
// ./src/views/common/LabelParts.jsx